import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=42e9a0d3&scoped=true&"
import script from "./UiButton.vue?vue&type=script&lang=js&"
export * from "./UiButton.vue?vue&type=script&lang=js&"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=42e9a0d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e9a0d3",
  null
  
)

export default component.exports